import * as _ from "lodash";
import * as angular from "angular";
import { CheckManager } from "../../shared/check-manager";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { Filter } from "../../models/filter.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { StreetDataProvider } from "../../data-provider/street.dp";
import { Group } from "../../models/group.model";
import { SearchUtils } from "../../helper/search.helper";

let StreetListComponent = {
    selector: "vcStreetList",
    templateUrl: "/angular/components/street/street-list.component.html",
    bindings: {
        selectedStreet: "=",
    },
    controller: class StreetListController {
        // * bindings for typescript compiler *
        public selectedStreet: any;
        // ************************************

        private $scope: any;
        private $window: any;
        private $filter: any;
        private __app_type: string;
        private $interval: any;
        private $location: any;
        private toast: ToastUtils;
        public dataProvider: StreetDataProvider;
        private permissionProvider: PermissionCheck;
        private navigationBarService: NavigationBarHelperService;
        private searchUtils: SearchUtils;
        private $q: any;
        private filterDataProvider: FilterDataProvider;
        private effortDataProvider: EffortDataProvider;
        private __env: any;
        private dialog: DialogUtils;
        private readonly $timeout: any;

        private filter: Filter;
        private subheading: string;
        private isLeaderView: boolean;
        private search: string;
        private columns: any;
        private checkManager: CheckManager;
        private searchDelay: number;
        private previousFilter: Filter;

        constructor(
            $scope: any,
            ToastUtils: ToastUtils,
            StreetDataProvider: StreetDataProvider,
            $window: any,
            $filter: any,
            __app_type: string,
            $interval: any,
            $location: any,
            PermissionCheck: PermissionCheck,
            NavigationBarHelperService: NavigationBarHelperService,
            SearchUtils: SearchUtils,
            $q: any,
            FilterDataProvider: FilterDataProvider,
            EffortDataProvider: EffortDataProvider,
            __env: any,
            $timeout: any,
            DialogUtils: DialogUtils
        ) {
            this.$scope = $scope;
            this.toast = ToastUtils;
            this.dataProvider = StreetDataProvider;
            this.$window = $window;
            this.$filter = $filter;
            this.__app_type = __app_type;
            this.$interval = $interval;
            this.$location = $location;
            this.permissionProvider = PermissionCheck;
            this.navigationBarService = NavigationBarHelperService;
            this.searchUtils = SearchUtils;
            this.$q = $q;
            this.filterDataProvider = FilterDataProvider;
            this.effortDataProvider = EffortDataProvider;
            this.__env = __env;
            this.dialog = DialogUtils;
            this.$timeout = $timeout;

            this.checkManager = this.dataProvider.checkManager;
            this.filterDataProvider.setPage("database");
            this.filter = this.filterDataProvider.appliedFilter;
            this.checkManager.checkAll(false);
            this.subheading =
                "Streets will display here once you import your " +
                this.__env.strings.voters +
                " file";
            this.isLeaderView = this.__app_type == "LEADER";
            if (this.filter.search && this.filter.search.values) {
                this.searchUtils.searchText = _.cloneDeep(
                    this.filter.search.values
                );
                this.search = this.searchUtils.searchText;
            }

            this.dataProvider.getColumns().then((columns: object) => {
                this.columns = columns;
            });

            this.searchUtils.setSearchBar(
                "Search Streets",
                (searchText: string) => {
                    this.search = searchText;
                    return this.$q.resolve([]); //Not using the results for the search dropdown so return empty.
                },
                null,
                true
            );

            this.$scope.$watch(
                () => this.search,
                (newValue: string, oldValue: string) => {
                    if (oldValue != newValue) {
                        this.dataProvider.loading = true;
                        if (this.searchDelay) {
                            this.searchDelay = this.$interval.cancel(
                                this.searchDelay
                            );
                        }
                        this.searchDelay = this.$interval(() => {
                            this.$interval.cancel(this.searchDelay);
                            this.filterDataProvider.filter.search.values =
                                this.search;
                        }, 1500);
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.filter,
                (newValue: Filter, oldValue: Filter) => {
                    if (
                        !this.previousFilter ||
                        (Object.keys(newValue).length &&
                            !Object.keys(oldValue).length) ||
                        (newValue &&
                            !angular.equals(
                                newValue.nonEmptyValues(),
                                oldValue.nonEmptyValues()
                            ))
                    ) {
                        this.previousFilter = _.cloneDeep(newValue);
                        this.dataProvider.setFilters(this.filter);
                    }
                },
                true
            );
        }

        $onInit() {
            this.$timeout(() => {
                if (this.filterDataProvider.isSearchActive()) {
                    this.searchUtils.searchText = angular.copy(
                        this.filterDataProvider.non_empty_applied_fitlers.search
                    );
                    this.navigationBarService.setSearchMode(true);
                }
            }, 500);
        }

        streetClicked(street: any): void {
            let selectedStreet = encodeURIComponent(
                JSON.stringify({
                    street: street.haddress,
                    city: street.hcity,
                    state: street.hstate,
                })
            );

            this.filterDataProvider.appliedFilter.search.values = "";
            this.filterDataProvider.filter.search.values = "";
            this.searchUtils.searchText = "";
            this.search = "";

            this.$window.location =
                "/#/houses?filter=" +
                JSON.stringify(this.filter.nonEmptyValues()) +
                "&street=" +
                selectedStreet;
        }

        scrollLoad(lastStreet: object): void {
            if (!this.dataProvider.scrollLoading) {
                this.dataProvider.getFilteredStreets(lastStreet, true);
            }
        }

        getStatus(statuses: Array<any>, statusId: number | string): string {
            let returnValue = "";
            angular.forEach(statuses, (status) => {
                if (status.id == statusId) {
                    returnValue = status.count;
                }
            });
            return returnValue;
        }

        deleteListModal(ev: object): void {
            this.dialog
                .delete({
                    targetEvent: ev,
                    fullscreen: true,
                    skipHide: true,
                    locals: {
                        bodyText: `They will be permanently deleted`,
                        title: `Delete ${this.$filter("number")(
                            this.dataProvider.checkManager.checked_items_count
                        )} Streets?`,
                    },
                })
                .then(() => {
                    this.dataProvider.bulkDelete().then(
                        () => this.toast.success("Streets deleted"),
                        () => this.toast.error()
                    );
                });
        }

        showBadgeHelp(ev: object): void {
            this.dialog.show({
                component: "vc-badge-help",
                targetEvent: ev,
                scope: this.$scope,
                locals: {
                    showLocationNumbers: false,
                    pageName: "street",
                    __env: this.__env,
                },
            });
        }

        bulk_group(ev: object): void {
            this.dialog
                .show({
                    component: "vc-group-selection-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    locals: {
                        provider: null,
                    },
                })
                .then((group: Group) => {
                    let bulkActionData = this.checkManager.bulkActionData(
                        this.filter
                    );
                    bulkActionData["constituent_filters_select_all"] = true;
                    bulkActionData["data_type"] = "streets";
                    group
                        .addMembers({ members: [bulkActionData] }, this.dialog)
                        .then(
                            (group: Group) => {
                                this.toast.success(
                                    "Streets added to " + group.gname
                                );
                                this.checkManager.checkAll(false);
                            },
                            (data: any) => {
                                this.checkManager.setLoading(false);
                                if (data.tooBig) {
                                    this.listTooBig();
                                } else {
                                    this.toast.error();
                                }
                            }
                        );
                });
        }

        listTooBig(): void {
            this.checkManager.setLoading(false);
            const listToBigAlert = this.dialog
                .alert()
                .title(`List Too Big`)
                .htmlContent(
                    `<p class="no-margin">We cannot complete this action as it will result in exceeding the list size maximum of 20,000 ${this.__env.strings.voters}.</p>
                        <p class="no-margin">List limits are in place to prevent excessive mobile data usage and provide an optimal experience using the mobile app.</p>`
                )
                .escapeToClose(false)
                .ok("Close");
            this.dialog.showPreConfiguredDialog(listToBigAlert);
        }
    },
};

angular
    .module("street", ["checkManager"])
    .component(StreetListComponent.selector, StreetListComponent);
